import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    AbstractControl,
    UntypedFormBuilder,
    Validators
} from '@angular/forms';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
    @Output() emailOrPhoneProvided = new EventEmitter<string>();

    @Input() busy = false;

    formGroup = this._fb.group({
        emailOrPhone: [null, Validators.required]
    });

    constructor(
        private readonly _fb: UntypedFormBuilder,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {}

    ngOnInit(): void {
        this._googleAnalyticsService.pageView('Sign in');
    }

    get emailOrPhone(): AbstractControl | null {
        return this.formGroup.get('emailOrPhone');
    }

    emailOrPhoneSubmitted(): void {
        if (this.formGroup.valid) {
            this.emailOrPhoneProvided.next(this.emailOrPhone?.value);
        }
    }
}
